import AppointmentList from './appointment-list';
import ProjectList from './projet-list';
import { useAuth } from '@/providers/auth-provider';

export default function Home() {
  const { user } = useAuth();

  const isInstaller = user?.user_metadata?.role === 'installer';

  const ContentComponent = isInstaller ? AppointmentList : ProjectList;
  return <ContentComponent />;
}
